import { useActions, useProductFilters } from "@nosto/search-js/preact/hooks"
import Toggle from "@/elements/Toggle/Toggle"
import styles from "./SpecialFilters.module.css"

/*
 * These come back from the backend as ordinary term facets, but we surface
 * them as on/off switches above the menu instead. FilterSidebar uses
 * SPECIAL_FILTER_FIELDS to hide them from the regular facet list.
 */
export const SPECIAL_FILTERS = [
  { label: "Hide Out of Stock", field: "availability", value: "In Stock" },
  { label: "USA Made only", field: "customFields.country of origin", value: "Yes" }
] as const

export const SPECIAL_FILTER_FIELDS: string[] = SPECIAL_FILTERS.map(filter => filter.field)

export default function SpecialFilters() {
  const { toggleProductFilter } = useActions()
  const { filters } = useProductFilters()

  const isActive = (field: string, value: string) =>
    filters.some(filter => filter?.field === field && filter?.value === value)

  return (
    <div className={styles.wrapper}>
      {SPECIAL_FILTERS.map(({ label, field, value }) => (
        <Toggle
          key={field}
          label={label}
          checked={isActive(field, value)}
          onChange={on => toggleProductFilter(field, value, on)}
        />
      ))}
    </div>
  )
}
